/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';
import { isMobile } from '@/commons/utils/responsive';

import * as Layouts from "@/commons/layouts";

const KelasTable = ({ kelasDataList, semesterSelectionField,
		 

	}) => {
  const { checkPermission } = useAuth();
  
  
  
  
  const navigate = useNavigate();
  const detail = async (kelasItem) => {
    isMobile() && navigate(`/kelas/${kelasItem.id}`);
  };
  
  
  return (
  <>
    <Layouts.ListComponentTableLayout
  	  items={[kelasDataList]}
  	  detail={detail}
  	  isSearchable
  	  filterFields={[
  	    {
  	      label: "Semester",
  	      featureName: "semesterName",
  	      options: semesterSelectionField,
            editable: false,
  	    }
  	  ]}
  	  itemsAttrs={[
          {
            id: "nama",
            condition: "",
            label: "Nama",
  		  featureName: "nama",
            editable: false
          }
  ,
          {
            id: "kapasitas",
            condition: "",
            label: "Kapasitas",
  		  featureName: "kapasitas",
            editable: false
          }
  ,
          {
            id: "ruangan",
            condition: "",
            label: "Ruangan",
  		  featureName: "ruangan",
            editable: false
          }
  ,
          {
            id: "jadwal",
            condition: "",
            label: "Jadwal",
  		  featureName: "jadwal",
            editable: false
          }
  ,
          {
            id: "mataKuliah",
            condition: "",
            label: "Mata Kuliah",
  		  featureName: "mataKuliahNama",
            editable: false
          }
  ,
          {
            id: "semester",
            condition: "",
            label: "Semester",
  		  featureName: "semesterName",
            editable: false
          }
  ,
          {
            id: "dosen",
            condition: "",
            label: "Dosen",
  		  featureName: "dosen",
            editable: false
          }
  ,
  ]}
  itemsEvents={(kelasItem) => [
    <Link to={`/kelas/${kelasItem.id}`}>
      <Button variant="primary">Detail</Button>
    </Link>,
  ]}
    	  itemsModals={(kelasItem) => [
        ]}
  	/>
  </>
  )
};

export default KelasTable;
